import { cn } from "@/lib/utils";
import { STATUS_LABEL } from "@/lib/format";

const STYLES = {
  open: "border-sky-500/50 text-sky-600 dark:text-sky-300 bg-sky-500/10",
  working: "border-emerald-500/60 text-emerald-600 dark:text-emerald-300 bg-emerald-500/10",
  pending_approval: "border-purple-500/60 text-purple-600 dark:text-purple-300 bg-purple-500/10",
  closed: "border-border text-muted-foreground bg-muted/60",
};

export function StatusChip({ status, className, ...props }) {
  return (
    <span className={cn("mono inline-flex items-center gap-1.5 border px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider", STYLES[status] || STYLES.open, className)} {...props}>
      {status === "working" && <span className="live-dot" />}
      {STATUS_LABEL[status] || status}
    </span>
  );
}

export function Tag({ children, tone = "neutral", className, ...props }) {
  const tones = {
    neutral: "border-border text-muted-foreground",
    amber: "border-amber-500/60 text-amber-600 dark:text-amber-300 bg-amber-500/10",
    red: "border-red-500/60 text-red-600 dark:text-red-300 bg-red-500/10",
    purple: "border-purple-500/60 text-purple-600 dark:text-purple-300 bg-purple-500/10",
    cyan: "border-cyan-500/60 text-cyan-600 dark:text-cyan-300 bg-cyan-500/10",
    emerald: "border-emerald-500/60 text-emerald-600 dark:text-emerald-300 bg-emerald-500/10",
    blue: "border-blue-500/60 text-blue-600 dark:text-blue-300 bg-blue-500/10",
  };
  return (
    <span className={cn("mono inline-flex items-center border px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider", tones[tone], className)} {...props}>
      {children}
    </span>
  );
}

export function tagTone(tag) {
  if (tag.startsWith("REASSIGNED")) return "amber";
  if (tag === "ROTTING") return "red";
  if (tag.startsWith("RESTORED")) return "cyan";
  return "neutral";
}
